var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27H4V5h9V3H3a1 1 0 00-1 1v24a1 1 0 001 1h18a1 1 0 001-1V12h-2v15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.06V9a1 1 0 001 1h5.941l-6.94-6.94zM17 16h-4v-4h-2v4H7v2h4v4h2v-4h4zM29.707 5.234L27.473 3h-2.828L28 6.355v6.586h2v-7a1 1 0 00-.293-.707"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.355v10.586h2v-11a.996.996 0 00-.293-.707L23.473 5h-2.828L24 8.355z"
  })))));
}

export default SvgIconCopy;